import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";

interface IIconWrapper {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export const IconWrapper: React.FC<IIconWrapper> = ({
  children,
  onClick,
  disabled,
}) => {
  return (
    <Wrapper onClick={onClick} $disabled={disabled}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled(Row).attrs({
  align: "center",
  justify: "flex-start",
})<{ $disabled?: boolean }>`
  padding-left: ${getSpacing("1/2x")};
  margin-bottom: ${getSpacing("1/2x")};
`;
